module.exports = __webpack_public_path__ + "static/img/wzmacniacz.bcd2727.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/wzmacniacz.svg
// module id = ezN1
// module chunks = 1